import React from 'react'
import Greviencecommitteetable from '../../Components/GrevienceCommittee/GreviencecommitteeTable';

const GrevienceCommittee = () => {
  const gravienceHead =()=>{

  }
  return (
    <div> 
         <div class="navbar navbar-expand-lg navbar-light">
    {/* <div class="container">
      <a class="navbar-brand" href="#">
      INSTITUTE LEVEL COMMITTEES
      </a>
    </div> */}
  </div>
 <Greviencecommitteetable Heading={gravienceHead}/>
</div>
  )
}

export default GrevienceCommittee;